import { useState } from "react";
import styled from "styled-components";
import CustomIcon from "../Icons/CustomIcon";

const SearchBarContainer = styled.div`
    position: inherit;
    width: 304px;
    height: 56px;
    left: 19px;
    top: 16px;
    background: #F2F6F7;
    border-radius: 28px;

    display: flex;
    align-items: center;

    .icon{
        margin-left: 18px;
        margin-right: 10px;
    }
`;

const TextContent = styled.input`
    position: inherit;
    left: 44px;
    right: 16px;
    top: 20px;
    bottom: 20px;

    /* UI/M */

    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    /* identical to box height, or 16px */

    display: flex;
    align-items: center;

    /* Secondary/Cool Gray/10 */
    color: #63666A;
    background: none;
    border: none;

    outline: none;
    width: 190px;
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #d3d3d3;
        opacity: 1; /* Firefox */
    }
`;


export const SearchBar = () => {
    const [searchText, setSearchText] = useState('');

    return(
        <SearchBarContainer>
            <CustomIcon icon={'Search_sm'} fill='#0076A8'/>
            <TextContent placeholder="Search" value={searchText} onChange={(e) => setSearchText(e.target.value)}/>
            <CustomIcon icon={'ClearDelete'} visibility={searchText !== '' ? null : 'hidden'} onClick={() => setSearchText('')}/>
        </SearchBarContainer>
    );
};